<p-toast key="global-toast" [life]="3000" position="bottom-right"></p-toast>
<app-notification-toast-host />
<router-outlet></router-outlet>
